import { useEffect } from 'react';

const MANAGED_SELECTOR = 'data-stavyn-seo';

function upsertMeta(attr, key, content) {
  if (content == null || content === '') return;
  let el = document.head.querySelector(`meta[${attr}="${key}"][${MANAGED_SELECTOR}]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    el.setAttribute(MANAGED_SELECTOR, 'true');
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"][${MANAGED_SELECTOR}]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    el.setAttribute(MANAGED_SELECTOR, 'true');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function removeManagedJsonLd() {
  document.head.querySelectorAll(`script[type="application/ld+json"][${MANAGED_SELECTOR}]`).forEach((n) => n.remove());
}

/**
 * Updates document title, meta tags, canonical URL, and optional JSON-LD.
 * @param {{
 *   title: string,
 *   description: string,
 *   canonicalUrl?: string,
 *   ogType?: string,
 *   ogImage?: string,
 *   robots?: string,
 *   jsonLd?: object,
 * }} meta
 */
export default function Seo({
  title,
  description,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  robots,
  jsonLd,
}) {
  useEffect(() => {
    if (title) document.title = title;

    upsertMeta('name', 'description', description);
    upsertMeta('name', 'robots', robots);

    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', ogType);
    upsertMeta('property', 'og:url', canonicalUrl);
    if (ogImage) upsertMeta('property', 'og:image', ogImage);

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    if (ogImage) upsertMeta('name', 'twitter:image', ogImage);

    upsertLink('canonical', canonicalUrl);

    removeManagedJsonLd();
    if (jsonLd) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute(MANAGED_SELECTOR, 'true');
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, canonicalUrl, ogType, ogImage, robots, jsonLd]);

  return null;
}
